<div class="gallery-item" [ngClass]="{'loaded': isLoaded || item.type === 'video'}" #mainEl>
  <ng-container *ngIf="item.type === 'image'">
    <div class="gallery-item__image">
      <brt-image [image]="item.image" *ngIf="item.image" (loaded)="itemLoaded()"></brt-image>
    </div>
  </ng-container>
  <ng-container *ngIf="item.type === 'video'">
    <div class="gallery-item__video" (click)="openVideoOverlay($event)">
      <brt-embed-video [data]="item.video" *ngIf="item.video" [object-fit]="objectFit"></brt-embed-video>
    </div>
  </ng-container>
</div>
